import { JSONObject } from '../../types/types';
import { resolveStringPlaceholders } from '../json/resolveStringPlaceholders';

// Resolves one pair side and url-encodes the RESULT; null/undefined encodes to ''.
export const resolvePairSide = async (
  template: string,
  templateData: JSONObject
): Promise<string> => {
  const resolved = await resolveStringPlaceholders(template, templateData);
  return resolved == null ? '' : encodeURIComponent(String(resolved));
};
